/**
 * ProgressBar — DS Molecule
 */

import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  value: number;  /** 0–100 */
  label?: string;
  variant?: 'primary' | 'action' | 'warning' | 'danger';
  showPercent?: boolean;
  className?: string;
}

export function ProgressBar({ value, label, variant = 'primary', showPercent = false, className = '' }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));
  return (
    <div className={`${styles.wrapper} ${className}`}>
      {(label || showPercent) && (
        <div className={styles.header}>
          {label && <span className={styles.label}>{label}</span>}
          {showPercent && <span className={styles.percent}>{clamped}%</span>}
        </div>
      )}
      <div className={styles.track}>
        <div className={`${styles.bar} ${styles[variant]}`} style={{ width: `${clamped}%` }} />
      </div>
    </div>
  );
}
